import DgCard from 'styles/UI/Card/DgCard';
import DgCardHeader from 'styles/UI/CardHeader/DgCardHeader';
import AdminUserInvoiceTable from './components/AdminUserInvoiceTable';

const AdminUserInvoice = () => {
	return (
		<DgCard>
			<DgCardHeader title='invoice-history' tabTitle='my-wallet' />

			<AdminUserInvoiceTable />
		</DgCard>
	);
};

export default AdminUserInvoice;
